import { attrConfig as tabTypeConfig } from './w-tab-type.js';
import { attrConfig as tabLeaderConfig } from './w-tab-leader.js';
import { attrConfig as tabPosConfig } from './w-tab-pos.js';

/** @type {import('@translator').AttrConfig[]} */
export default [tabTypeConfig, tabPosConfig, tabLeaderConfig];
